/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardHealthCheckItemModel } from '../../models/dashboard-health-check-item-model';
import { DashboardRequestModel } from '../../models/dashboard-request-model';

export interface DashboardOrganizationScanSummaryOrganizationIdPost$Params {

/**
 * The unique identifier of the organization
 */
  organizationId: string;
  
    /**
     * The dashboard request model containing date range and summary type
     */
    body?: DashboardRequestModel
}

export function dashboardOrganizationScanSummaryOrganizationIdPost(http: HttpClient, rootUrl: string, params: DashboardOrganizationScanSummaryOrganizationIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<DashboardHealthCheckItemModel>>> {
  const rb = new RequestBuilder(rootUrl, dashboardOrganizationScanSummaryOrganizationIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<DashboardHealthCheckItemModel>>;
    })
  );
}

dashboardOrganizationScanSummaryOrganizationIdPost.PATH = '/Dashboard/OrganizationScanSummary/{organizationId}';
